import { getOwnerFromUser, mapPublicToQuote } from '@paintscout/util/builder'
import type { QuoteDocument } from 'paintscout'
import React, { useEffect } from 'react'
import { getUrlQuery } from 'shared/util/routing'
import EditableQuote from 'src/components/common/EditableQuote/EditableQuote'

import { useClientOptions, useUser } from '@paintscout/ui'
import { Redirect, useHistory, useLocation } from 'react-router-dom'

interface UrlQuery {
  publicQuote?: string
}

export default function NewQuote() {
  const { options } = useClientOptions()

  // Temporary until we can make sure we have billingId's set
  // correctly for everyone existing.
  const { isTrial, user, trialExpired } = useUser()

  const history = useHistory()
  const location = useLocation<any>()

  // comes from CheckQuoteRecovery
  const recoveryData = location.state?.recoveryData

  // location.state.quote is set from CreateQuoteDialog

  let quote: QuoteDocument

  const { publicQuote: publicQuoteJSON } = getUrlQuery<UrlQuery>({ location })
  if (publicQuoteJSON) {
    const publicQuote = JSON.parse(publicQuoteJSON)

    console.log({ publicQuote })
    const owner = getOwnerFromUser(user)

    quote = mapPublicToQuote({ publicQuote, options, owner })
  } else if (recoveryData?.quote) {
    quote = recoveryData?.quote
  } else {
    quote = location.state?.quote
  }

  useEffect(() => {
    // check trialExpired once on page load - redirect to dashboard (which will show trial over dashboard)
    if (isTrial && trialExpired) {
      history.replace('/dashboard')
    }
  }, [])

  if (!quote) {
    return <Redirect to="/quotes" />
  }

  return (
    <EditableQuote
      isNew
      shouldSaveContact
      quote={quote}
      recoveryData={recoveryData}
      onSaved={() => {
        if (quote.is_invoice) {
          history.replace(`/invoices/edit/${quote._id}`, {
            skipDirtyPrompt: true
          })
        } else {
          history.replace(`/quotes/edit/${quote._id}`, {
            skipDirtyPrompt: true
          })
        }
      }}
    />
  )
}
